'use strict'

exports.callsitesSym = Symbol('callsites')
